import { AboutPage } from '../public/pages/AboutPage';
import { BooksMediaPage } from '../public/pages/BooksMediaPage';
import { ContactPage } from '../public/pages/ContactPage';
import { EngagementsPage } from '../public/pages/EngagementsPage';
import { HomePage } from '../public/pages/HomePage';
import { NotFoundPage } from '../public/pages/NotFoundPage';
import { SpeakingPage } from '../public/pages/SpeakingPage';
import { AdminApp } from '../admin/AdminApp';
import { CustomPageRoute } from '../public/pages/CustomPage';

export function CurrentRoute() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';

  if (path === '/') return <HomePage />;
  if (path === '/about') return <AboutPage />;
  if (path === '/speaking') return <SpeakingPage />;
  if (path === '/engagements') return <EngagementsPage />;
  if (path === '/books-media') return <BooksMediaPage />;
  if (path === '/contact') return <ContactPage />;
  if (path === '/admin' || path.startsWith('/admin/')) return <AdminApp />;

  if (path.startsWith('/pages/')) {
    const slug = decodeURIComponent(path.slice('/pages/'.length));
    return <CustomPageRoute slug={slug} />;
  }

  return <NotFoundPage />;
}
